import React from "react";
import { Form, Col } from 'react-bootstrap';
import IconButton from "../../IconButton/IconButton";
import ToolTip from "../../ToolTip/Tooltip";
import { SvgComponent } from "../../SvgComponent/SvgComponent";
export const InputSidebarContainer = ({
                                          children,
                                          label,
                                          colSize,
                                          style,
                                          justify = "left",
                                          labelSize = "6",
                                          crearNuevo,
                                      }) => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: justify,
                width: `100%`,
            }}
        >
            <Col sm={colSize || "12"} style={{ ...style }}>
                <Form.Group>
                    {label && (
                        <>
                            <Form.Label column sm={labelSize} className="pl-0">
                                {label}
                            </Form.Label>
                            {crearNuevo && (
                                <Form.Label column sm={12 - labelSize} className="pl-0">
                                    <IconButton onClick={() => crearNuevo()}>
                                        <ToolTip message="Editar">
                                            <div>
                                                <SvgComponent
                                                    iconName="circle-plus"
                                                    height="25px"
                                                    width="25px"
                                                />
                                            </div>
                                        </ToolTip>
                                    </IconButton>
                                </Form.Label>
                            )}
                        </>
                    )}
                    {children}
                </Form.Group>
            </Col>
        </div>
    );
};
